'use client';
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Thumbnail;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const utils_1 = require("../utils");
function Thumbnail({ width: _width, height: _height, url, imageSize, className, alt = '' }) {
    const [isLoadingAsynchronously, setIsLoadingAsynchronously] = (0, react_1.useState)(true);
    const [hasLoadedAsynchronously, setHasLoadedAsynchronously] = (0, react_1.useState)(false);
    const [width, setWidth] = (0, react_1.useState)(null);
    const [height, setHeight] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        const img = new Image();
        img.onload = function onLoad() {
            setIsLoadingAsynchronously(false);
            setHasLoadedAsynchronously(true);
            setWidth(img.width);
            setHeight(img.height);
        };
        img.src = url;
        return () => {
            img.src = '';
        };
    }, []);
    const isPortrait = height && width && height > width;
    const thumbnailClasses = (0, utils_1.cn)('relative block max-w-full overflow-hidden rounded-2xl bg-neutral-50', isPortrait ? 'h-auto w-full' : 'pb-[100%]', className);
    return ((0, jsx_runtime_1.jsx)("div", { className: thumbnailClasses, style: imageSize ? { width: `${imageSize}px`, height: `${imageSize}px`, paddingBottom: 0 } : {}, children: (isLoadingAsynchronously && hasLoadedAsynchronously) || !isLoadingAsynchronously ? ((0, jsx_runtime_1.jsx)("img", { alt: alt, className: 'absolute top-1/2 left-1/2 h-full w-auto -translate-x-1/2 -translate-y-1/2 select-none', src: url, style: imageSize ? { width: `${imageSize}px`, height: `${imageSize}px` } : {} })) : null }));
}
